import { RestrictionType, RouteRestriction } from './route.restriction';

export const ROUTE_RESTRICTIONS: Record<RestrictionType, RouteRestriction> = {
  IS_ADMIN: (user) => user?.isAdmin || false,
  // TODO
  IS_CLIENT: (user) => false, //!!user.selectedClient,
  IS_EMPLOYEE: (user) => false, //!!user.selectedEmployee,
}